import React from 'react';
import DocumentIcon from './assets/document.svg';
import SunIcon from './assets/sun.svg';
import ReverseIcon from './assets/reverse.svg';

import './assets/c-capture-steps.scss';

const steps = [
    [DocumentIcon, 'sem plastificação, se possível'],
    [SunIcon, 'com boa iluminação e legível'],
    [ReverseIcon, 'foto da frente e verso do documento'],
];

const CaptureSteps: React.FC = (): JSX.Element => (
    <div className="c-capture-steps">
        <h3>Envie as fotos:</h3>

        <div className="c-capture-steps__inner">
            {steps.map(([image, title], key) => (
                <div key={key} className="c-capture-steps__item">
                    <div>
                        <img src={image} alt={title} />
                    </div>
                    <p>{title}</p>
                </div>
            ))}
        </div>
    </div>
);

export default CaptureSteps;